import api from '@/api/roleManagement'

const state = {

}

const actions = {
  getRoleList (context, params) {
    return api.getRoleList(params)
  },
  addRole (context, data) {
    return api.addRole(data)
  },
  getPermissionsList (context, params) {
    return api.getPermissionsList(params)
  },
  roleNameValidate (context, params) {
    return api.roleNameValidate(params)
  },
  getRole (context, { roleId, params }) {
    return api.getRole(roleId, params)
  },
  updateRole (context, { roleId, data }) {
    return api.updateRole(roleId, data)
  },
  deleteRole (context, roleId) {
    return api.deleteRole(roleId)
  },
  exportRoleList (context, params) {
    return api.exportRoleList(params)
  },
  saveRole (context, data) {
    return api.saveRole(data)
  },
  resetPassword (context, accountId) {
    return api.resetPassword(accountId)
  },
  roleEmailValidate (context, data) {
    return api.roleEmailValidate(data)
  },
  roleMobileValidate (context, data) {
    return api.roleMobileValidate(data)
  },
  getRoleDefaultInfo () {
    return api.getRoleDefaultInfo()
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
